module.exports = __webpack_public_path__ + "media/images/pc/specials/okinawa_churaumi_aquarium/anchor_arrow_white-82897eb9804e11be78734227dc6795c0.svg";